export default __webpack_public_path__ + "static/gem-visa-card-illustrated-21088c23c39d01359f794ea6c762af60.png";